/* eslint-disable */
import $ from 'jquery';
import BaseModule from './BaseModule';

export default class ScrollTo extends BaseModule {
  constructor(el, factory) {
    super(el, factory, 'ScrollTo');

    $('.scroll-to').on('click', function(event) {
      event.preventDefault();
      const _this = $(this);

      if ($('.section-vehicle-nav.nav-wrapper').length && $(window).width() < 768) {
        console.log(true);
        let nav = $('.section-vehicle-nav.nav-wrapper .nav');

        if (nav.hasClass('expanded')) {
          nav.removeClass('expanded');
        } else {
          nav.addClass('expanded');

          if ($('.section-vehicle-nav.nav-wrapper.sticky').length) {
            return;
          }
        }
      }

      $('.scroll-to').removeClass('active');
      _this.addClass('active');

      const thisTarget = $(this).attr('data-target');
      const offset = -Math.abs($(el).height());
      $('body').addClass('scroll-animating');

      if (thisTarget !== "#top") {
        $('html, body').animate({
          scrollTop: $(thisTarget).offset().top + offset
        }, 800, function() {
          $('body').removeClass('scroll-animating');
        });
      } else {
        $('html, body').animate({
          scrollTop: 0
        }, 800, function() {
          $('body').removeClass('scroll-animating');
        });
      }
    });
  }
}
